export const socials = [
    {
        title: "DI",
        link: "https://discord.com/invite/Yxwzm9Zp"
    },
    {
        title: "TW",
        link: "https://twitter.com/IC_Planets"
    },
    {
        title: "DS",
        link: "https://dscvr.one/p/icplanets"
    },
]
export const marketLink = "https://tppkg-ziaaa-aaaal-qatrq-cai.raw.ic0.app"
